import { defineStore } from 'pinia'

const SIZE_QTY_KEY = 'defaultSizeQuantities'
const WORKBOOK_MODE_KEY = 'workbookMode'
const CANONICAL_ORDER = ['One Size', 'XS', 'SM', 'MD', 'LG', 'XL', 'XXL', 'XXXL'] as const
type Canon = typeof CANONICAL_ORDER[number]

const DEFAULT_SIZE_QUANTITIES: Record<Canon, number> = {
  'One Size': 1, XS: 1, SM: 2, MD: 2, LG: 2, XL: 1, XXL: 1, XXXL: 0
}

const DEFAULT_WORKBOOK_MODE = 'All'

export const useSettingsStore = defineStore('settings', {
  state: () => ({
    currency: 'CAD',
    defaultSizeQuantities: { ...DEFAULT_SIZE_QUANTITIES },
    workbookMode: DEFAULT_WORKBOOK_MODE
  }),
  getters: {
    sizes: (state) =>
      CANONICAL_ORDER.map((name) => ({
        name,
        qty: state.defaultSizeQuantities[name] ?? 0
      }))
  },
  actions: {
    setCurrency(val: string) {
      this.currency = val
      if (typeof window !== 'undefined') localStorage.setItem('currency', val)
    },
    setDefaultSizeQty(size: string, qty: number) {
      if (CANONICAL_ORDER.includes(size as Canon)) {
        this.defaultSizeQuantities[size as Canon] = Math.max(0, Math.floor(qty))
        this.persistDefaultSizeQuantities()
      }
    },
    resetDefaultSizeQuantities() {
      this.defaultSizeQuantities = { ...DEFAULT_SIZE_QUANTITIES }
      this.persistDefaultSizeQuantities()
    },
    persistDefaultSizeQuantities() {
      if (typeof window !== 'undefined') {
        localStorage.setItem(SIZE_QTY_KEY, JSON.stringify(this.defaultSizeQuantities))
      }
    },
    setWorkbookMode(mode: string) {
      this.workbookMode = mode
      if (typeof window !== 'undefined') {
        localStorage.setItem(WORKBOOK_MODE_KEY, mode)
      }
    },
    hydrate() {
      if (typeof window === 'undefined') return
      const val = localStorage.getItem('currency')
      if (val) this.currency = val

      const raw = localStorage.getItem(SIZE_QTY_KEY)
      if (raw) {
        try {
          const parsed = JSON.parse(raw)
          if (parsed && typeof parsed === 'object') {
            this.defaultSizeQuantities = { ...DEFAULT_SIZE_QUANTITIES, ...parsed }
          }
        } catch {
          this.defaultSizeQuantities = { ...DEFAULT_SIZE_QUANTITIES }
        }
      } else {
        this.defaultSizeQuantities = { ...DEFAULT_SIZE_QUANTITIES }
      }

      const mode = localStorage.getItem(WORKBOOK_MODE_KEY)
      if (mode) this.workbookMode = mode
      else this.workbookMode = DEFAULT_WORKBOOK_MODE
    }
  }
})